import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { LanguageProvider } from './i18n/i18n';
import reportWebVitals from './reportWebVitals';
import BAlogo from './assets/images/BA-logo-nobg.png';

const root = ReactDOM.createRoot(document.getElementById('root'));
 // Ensure the favicon uses the BA logo from the bundled assets
 try {
   const head = document.getElementsByTagName('head')[0];
   let link = head.querySelector("link[rel~='icon']");
   if (!link) {
     link = document.createElement('link');
     link.rel = 'icon';
     head.appendChild(link);
   }
   link.type = 'image/png';
   link.href = BAlogo;
 } catch (e) {
   // ignore any DOM errors
 }

 root.render(
  <React.StrictMode>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
